<ng-container *ngIf="isTimeSeries ? true : (chartDef.data | json) !== '{}'; else noData">
  <apx-chart
    class="flex-auto w-full h-full"
    [chart]="chartOptions.chart"
    [colors]="chartOptions.colors"
    [fill]="chartOptions.fill"
    [series]="chartOptions.series"
    [stroke]="chartOptions.stroke"
    [tooltip]="chartOptions.tooltip"
    [xaxis]="chartOptions.xaxis"
  ></apx-chart>
</ng-container>
<ng-template #noData>
  <p class="font-bold text-md text-secondary uppercase tracking-wider text-center p-4">
    Insufficient data to display graph
  </p>
</ng-template>
